import { DECORATION_COUPON } from '@constant'
import { dGet } from '@core/utils'
import { isUltimate } from '@merchant-backend/util'
import { isSiDaMember } from '@util'
import { Flex } from 'hljd'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import GiftRow from '../Common/GiftRow'
import Rowbox from '../Common/Rowbox'
import Item from './Item'
import style from './style.module.less'

@observer
export default class extends Component {
  showModule = (mode, coupons) => {
    // 三大个人，但团队未设置
    if (isSiDaMember() && coupons.length == 0) {
      return false
    }
    const { showAll } = this.props.store
    return (
      mode === 'editable' ||
      showAll ||
      (isUltimate() && mode === 'preview' && coupons.length > 0)
    )
  }

  render() {
    const { store } = this.props
    const { mode } = store
    const coupons = dGet(store, 'promiseData.coupons', []) || []

    return this.showModule(mode, coupons) ? (
      <Rowbox
        type={DECORATION_COUPON}
        store={store}
        style={{
          height: 75,
          padding: '0 0 0 16px',
          marginBottom: 0
        }}
        vCenter={false}
        disableEdit={isSiDaMember() && coupons.length > 0}
      >
        <GiftRow style={{ overflowX: 'auto' }} className={style.row}>
          <GiftRow.Title title="优惠券" num={`共${coupons.length}张可领`} />

          <Flex vc>
            {coupons.map(item => {
              return <Item key={item.id} {...item} />
            })}
          </Flex>
        </GiftRow>
      </Rowbox>
    ) : null
  }
}
